import { Link } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";

const Page = styled.main`
  display: grid;
  place-items: center;
  min-height: 100vh;
  padding: 6.5rem 1rem 2rem;
`;

const Card = styled.section`
  display: grid;
  gap: 1rem;
  width: min(680px, 100%);
  padding: 2rem;
  border-radius: ${({ theme }) => theme.radii.lg};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: rgba(255, 255, 255, 0.05);
  text-align: center;
`;

const Code = styled.span`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(5rem, 15vw, 9rem);
  line-height: 0.9;
  color: ${({ theme }) => theme.colors.red};
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.8rem, 4vw, 2.6rem);
`;

const Copy = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.75;
`;

function Erro() {
  return (
    <Page>
      <Card>
        <Code>404</Code>
        <Title>Essa tela saiu do catalogo</Title>
        <Copy>
          O caminho que voce tentou abrir nao existe ou foi movido. Vamos te levar de volta para a experiencia principal.
        </Copy>
        <Button as={Link} to="/">
          Voltar para a home
        </Button>
      </Card>
    </Page>
  );
}

export default Erro;
